export default __webpack_public_path__ + "static/media/pwa bell.ad7ec454.png";